import {
  Box,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@material-ui/core";
import { formatDistance } from "date-fns";
import { AdminSourceResponse } from "@authory-packages/core";
import { FieldSetStyles, TableWebsiteStyles } from "../../styles";

type SourceDiagnosticsProps = {
  source: AdminSourceResponse;
};

export const SourceDiagnostics = ({ source }: SourceDiagnosticsProps) => {
  const fieldSetStyles = FieldSetStyles();
  const tableStyles = TableWebsiteStyles();

  return (
    <fieldset className={fieldSetStyles.container}>
      <legend>Diagnostics:</legend>
      <Box>
        <Typography component="span" variant="body1">
          Last Crawl Completed:{" "}
        </Typography>
        <Typography component="span" variant="body2">
          {" "}
          {source.lastCrawlCompleted
            ? formatDistance(new Date(source.lastCrawlCompleted), new Date(), {
                addSuffix: true,
              })
            : "-"}
        </Typography>
      </Box>
      <Box>
        <Typography component="span" variant="body1">
          Last URL found:{" "}
        </Typography>
        <Typography component="span" variant="body2">
          {" "}
          {source.lastUrlFound
            ? formatDistance(new Date(source.lastUrlFound), new Date(), {
                addSuffix: true,
              })
            : "-"}
        </Typography>
      </Box>
      <Box mb={2}>
        <Typography component="span" variant="body1">
          Last Article Found:{" "}
        </Typography>
        <Typography component="span" variant="body2">
          {" "}
          {source.lastArticleFound
            ? formatDistance(new Date(source.lastArticleFound), new Date(), {
                addSuffix: true,
              })
            : "-"}
        </Typography>
      </Box>
      <Table
        size="small"
        className={tableStyles.root}
        style={{ width: "100%" }}
      >
        <TableHead>
          <TableRow>
            <TableCell align="center"></TableCell>
            <TableCell align="center">Counts</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell align="center">Accepted</TableCell>
            <TableCell align="center">
              {source.countsPerStatus.Accepted}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="center">Diffbot Analyze</TableCell>
            <TableCell align="center">
              {source.countsPerStatus.DiffbotAnalyze}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="center">Diffbot Analyze Check</TableCell>
            <TableCell align="center">
              {source.countsPerStatus.DiffbotAnalyzeCheck}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="center">Dynamic Analyze</TableCell>
            <TableCell align="center">
              {source.countsPerStatus.DynamicAnalyze}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="center">Dynamic Analyze Check</TableCell>
            <TableCell align="center">
              {source.countsPerStatus.DynamicAnalyzeCheck}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="center">Early Reject Check</TableCell>
            <TableCell align="center">
              {source.countsPerStatus.EarlyRejectCheck}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="center">Fullcrawl Autotune</TableCell>
            <TableCell align="center">
              {source.countsPerStatus.FullCrawlAutoTune}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="center">Error</TableCell>
            <TableCell align="center">
              {source.countsPerStatus.PermanentError}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="center">Processing</TableCell>
            <TableCell align="center">
              {source.urlCount -
                source.countsPerStatus.PermanentError -
                source.countsPerStatus.Accepted -
                source.countsPerStatus.Rejected}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="center">Rejected</TableCell>
            <TableCell align="center">
              {source.countsPerStatus.Rejected}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="center">Custom Extraction</TableCell>
            <TableCell align="center">
              {source.countsPerStatus.ShivaContentExtraction}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="center">Static Analyze</TableCell>
            <TableCell align="center">
              {source.countsPerStatus.StaticAnalyze}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="center">Static Calibrate</TableCell>
            <TableCell align="center">
              {source.countsPerStatus.StaticCalibrate}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="center">Static Score Compute</TableCell>
            <TableCell align="center">
              {source.countsPerStatus.StaticScoreCompute}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </fieldset>
  );
};
